import { render, staticRenderFns } from "./draft_2.vue?vue&type=template&id=a88215cc&scoped=true"
import script from "./draft_2.vue?vue&type=script&lang=js"
export * from "./draft_2.vue?vue&type=script&lang=js"
import style0 from "./draft_2.vue?vue&type=style&index=0&id=a88215cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88215cc",
  null
  
)

export default component.exports